export const initialState = {
  details: {
    changed: false
  }
};

export function reducer(state, action) {
  switch (action.type) {
    case 'OnInitState':
      return onInitState(state, action);
    case 'OnPropertyChanged':
      return onPropertyChanged(state, action);
    case 'OnFinancialIndicatorAdd':
      return onFinancialIndicatorAdd(state);
    case 'OnSave':
      return onSave(state);

    default:
      return state;
  }
}

function onInitState(state, action) {
  const { financialIndicator } = action;
  return {
    ...state,
    details: {
      ...state.details,
      id: financialIndicator.id,
      orderNo: financialIndicator.orderNo,
      code: financialIndicator.code,
      name: financialIndicator.name,
      attributeName: financialIndicator.attributeName,
      expression: financialIndicator.expression,
      comment: financialIndicator.comment,
      externalCode: financialIndicator.externalCode,
      styleId: financialIndicator.styleId,
      scale: financialIndicator.scale,
      readOnly: financialIndicator.readOnly,
      sensitiveInfo: financialIndicator.sensitiveInfo,
      changed: false
    }
  };
}

function onPropertyChanged(state, action) {
  const { propertyName, propertyValue } = action;
  return {
    ...state,
    details: {
      ...state.details,
      [propertyName]: propertyValue,
      changed: true
    }
  };
}

function onFinancialIndicatorAdd(state) {
  return {
    ...state,
    details: {
      ...state.details,
      id: null,
      orderNo: null,
      code: '',
      name: '',
      attributeName: '',
      expression: '',
      comment: '',
      externalCode: '',
      styleId: null,
      scale: 2,
      readOnly: false,
      sensitiveInfo: false,
      changed: false
    }
  };
}

function onSave(state) {
  return {
    ...state,
    details: {
      ...state.details,
      changed: false
    }
  };
}
